// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-benchmarking .table .record-name {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.home-benchmarking .table .record-name img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}
.home-benchmarking .table .record-name p {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/Home.scss"],"names":[],"mappings":"AAEI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AADN;AAEM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAAR;AAEM;EACE,iBAAA;AAAR","sourcesContent":[".home-benchmarking {\n  .table {\n    .record-name {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      img {\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        object-fit: cover;\n        margin-right: 10px;\n      }\n      p {\n        font-weight: bold;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
